import React from 'react';
import { Box, CircularProgress, Alert, List, ListItem, ListItemText, ListItemButton, ListItemAvatar, Avatar } from '@mui/material';
import { GradientText } from '../../utils/theme';
import { useNavigate } from 'react-router-dom';
import useOrderHistory from '../hooks/useOrderHistory';
import { Order } from '../types/order';
import FolderIcon from '@mui/icons-material/Folder';
import { routingPath } from '../../utils/path';

const OrderHistory = () => {
  const { orders, loading, error } = useOrderHistory();
  const navigate = useNavigate();

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  };

  const groupedOrders = orders.reduce((acc, order) => {
    const formattedDate = formatDate(order["納品希望日"]);
    if (!acc[formattedDate]) {
      acc[formattedDate] = [];
    }
    acc[formattedDate].push(order);
    return acc;
  }, {} as Record<string, Order[]>);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', flexDirection: 'column', minHeight: '60vh', bgcolor: 'grey.100', mt: 2, borderRadius: 1, mx: 'auto', width: '80%' }}>
      <GradientText variant="h6" gutterBottom sx={{ mt: 3 }}>
        発注履歴
      </GradientText>
      <List sx={{ width: '100%', ml: -2 }}>
        {Object.entries(groupedOrders)
          .sort(([dateA], [dateB]) => new Date(dateB).getTime() - new Date(dateA).getTime()) // 日付でソート
          .map(([date, orders]) => (
        <ListItem key={`${date}-${orders[0].id}`}>
          <ListItemButton
            onClick={() => navigate(routingPath.auth.orderDetail, { state: { orders } })}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
              }
            }}
          >
            <ListItemAvatar sx={{ minWidth: 40 }}>
              <Avatar>
                <FolderIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={`納品希望日: ${date}`}
              secondary={`注文数: ${orders.length}`}
              sx={{ ml: 1.5, whiteSpace: 'nowrap' }}
            />
          </ListItemButton>
        </ListItem>
          ))}
      </List>
    </Box>
  );
};

export default OrderHistory;
